import { render, staticRenderFns } from "./W0064V0001.vue?vue&type=template&id=7785d264&scoped=true&"
import script from "./W0064V0001.vue?vue&type=script&lang=js&"
export * from "./W0064V0001.vue?vue&type=script&lang=js&"
import style0 from "./W0064V0001.vue?vue&type=style&index=0&id=7785d264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7785d264",
  null
  
)

export default component.exports